import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=e5ce53f6&"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=ts&"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports